import React, {useCallback, useLayoutEffect, useState} from 'react'

import ErrorBoundary from "../../error-boundary"
import ReorderItem from "./reorder-item"
import DndManager from "../../gd-modules/dnd/managers/dnd-manager"

import ReorderListPreviewLayer from "./preview-layer/reorder-preview-layer"

export enum ReorderListType {
    VERTICAL    = 'vertical',
    HORIZONTAL  = 'horizontal',
}

export enum ReorderListDirection {
    TOP     = 'top',
    BOTTOM  = 'bottom',
    LEFT    = 'left',
    RIGHT   = 'right',
}

type Props = {
    items                   : {
        item        : any
        component   : any
    }[]

    previewLayerClasses?    : string
    dndManager?             : DndManager

    type                    : ReorderListType
    disabled?               : boolean

    keyFunction             : func
    onReorder               : {(reorderedItems: any[], itemMoved: any): void}
}

// const debug = "ReorderListNoDiv"
const debug = false

export default function ReorderListNoDiv(props: Props) {

    const [cards, setCards] = useState(props.items)

    useLayoutEffect(() => {
        // if update happens during drag in progress it will cause dnd malfunction
        // (some items become not dragable)
        const isDragInProgress = props.dndManager && props.dndManager.isDragging()

        if (!isDragInProgress /*&& !_.isEqual(props.items, cards)*/) {
            debug && console.log(debug, "useLayoutEffect setCards", props.items)
            setCards(props.items)
        }
    }, [props.items])

    const onMove = useCallback((mouseEvent: any, draggedCard: any, targetCard: any, vType: 'below' | 'above', hType: 'right' | 'left') => {
        const cardsItems = cards.slice()

        // find dragged item and remove dragged card
        _.remove(cardsItems, card=>_.isEqual(card.item, draggedCard.item))

        // add dragged item at target item position according type (above|below)
        //remove no items at index and add newItem at this position
        const index = _.findIndex(cardsItems, card => _.isEqual(card.item, targetCard.item))

        debug && console.log(debug, "onMove", props.type, vType, hType)

        switch (props.type) {
            case ReorderListType.VERTICAL     :
                switch (vType) {
                    case 'below'    : cardsItems.splice(index+1,0,draggedCard); break
                    case 'above'    :
                    default         : cardsItems.splice(index,0,draggedCard); break
                }
                break

            case ReorderListType.HORIZONTAL   :
                switch (hType) {
                    case 'right'    : cardsItems.splice(index+1,0,draggedCard); break
                    case 'left'     :
                    default         : cardsItems.splice(index,0,draggedCard); break
                }
                break
        }

        debug && console.log(debug, "onMove setCards", cardsItems)
        setCards(cardsItems)
    }, [props.items, cards])

    const onConfirm = (item: any) => {
        props.onReorder?.(_.map(cards, card=>card.item), item)
    }

    const dndManager = !props.disabled ? props.dndManager : undefined

    debug && console.log(debug, "render", cards)

    return (
        <>
            {_.map(cards, (card,key)=> {

                return (
                    <ErrorBoundary key={props.keyFunction ? props.keyFunction(card.item, key) : key}>
                        <ReorderItem data       = {card}
                                     dndManager = {dndManager}
                                     type       = {props.type}
                                     idFunction = {props.keyFunction}
                                     onMove     = {onMove}
                                     onConfirm  = {onConfirm}>
                            {card.component}
                        </ReorderItem>
                    </ErrorBoundary>
                )}

            )}

            <ReorderListPreviewLayer className  = {props.previewLayerClasses}
                                     dndManager = {dndManager}/>
        </>
    )
}

ReorderListNoDiv.defaultProps = {
    type: ReorderListType.VERTICAL
}
